var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGetLoanIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 36,
    viewBox: "0 0 46 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.631 32.841L0 22L3 19L11 24L34 0L37 2L13.65 32.653C13.2981 33.1148 12.7629 33.4009 12.1835 33.437C11.604 33.4731 11.0374 33.2556 10.631 32.841Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.497489,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 9H40C39.4477 9 39 8.55228 39 8C39 7.44772 39.4477 7 40 7H45C45.5523 7 46 7.44772 46 8C46 8.55228 45.5523 9 45 9Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.497489,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 18H33C32.4477 18 32 17.5523 32 17C32 16.4477 32.4477 16 33 16H45C45.5523 16 46 16.4477 46 17C46 17.5523 45.5523 18 45 18Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.497489,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 27H26C25.4477 27 25 26.5523 25 26C25 25.4477 25.4477 25 26 25H45C45.5523 25 46 25.4477 46 26C46 26.5523 45.5523 27 45 27Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.497489,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 36H19C18.4477 36 18 35.5523 18 35C18 34.4477 18.4477 34 19 34H45C45.5523 34 46 34.4477 46 35C46 35.5523 45.5523 36 45 36Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetLoanIcon3);
export default __webpack_public_path__ + "static/media/get-loan-icon-3.bee8d58b74a7533b6d3f7f579a1e171f.svg";
export { ForwardRef as ReactComponent };